import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';
import anime from 'animejs/lib/anime.es';

const fragments = {
  INPUT: '[data-fragment="BudgetRange.input"]',
  HANDLE: '[data-fragment="BudgetRange.handle"]',
  HANDLE_VALUE: '[data-fragment="BudgetRange.handleValue"]',
  RANGE: '[data-fragment="BudgetRange.range"]',
  LEVEL: '[data-fragment="BudgetRange.level"]',
  INFO: '[data-fragment="BudgetRange.info"]',
};

export default class BudgetRange extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
      moving: false,
      rangeLeft: 0,
      handleMouseOffset: 0,
      levelWidth: 0,
      rangeWidth: 0,
      handlePosition: 0,
      handleSnap: 0,
      windowWidth: 0,
    };
    this.startMoving = this.startMoving.bind(this);
    this.stopMoving = this.stopMoving.bind(this);
    this.move = this.move.bind(this);
    this.getMouseX = this.getMouseX.bind(this);
    this.setLevels = this.setLevels.bind(this);
    this.init = this.init.bind(this);
    this.redraw = this.redraw.bind(this);
    this.snapTo = this.snapTo.bind(this);
    this.goTo = this.goTo.bind(this);
  }
  didMount() {
    this.input = this.element.querySelector(fragments.INPUT);
    this.handle = this.element.querySelector(fragments.HANDLE);
    this.handleValue = this.element.querySelector(fragments.HANDLE_VALUE);
    this.range = this.element.querySelector(fragments.RANGE);
    this.levels = this.element.querySelectorAll(fragments.LEVEL);
    this.info = this.element.querySelectorAll(fragments.INFO);
    this.on('mousedown', fragments.HANDLE, this.startMoving);
    this.on('touchstart', fragments.HANDLE, this.startMoving);
    window.addEventListener('mouseup', this.stopMoving);
    window.addEventListener('touchend', this.stopMoving);
    window.addEventListener('mousemove', this.move);
    this.on('touchmove', fragments.HANDLE, this.move);
    window.addEventListener('resize', this.redraw);
    this.on('click', fragments.LEVEL, this.goTo);
    this.setState({
      windowWidth: window.innerWidth,
    });
    this.init();
  }

  init = () => {
    let activeLevel = null;
    let levelCount = 0;
    let levelCountPosition = 0;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const expectedBudget = urlParams.get('frm.expectedBudget');
    if (expectedBudget) {
      activeLevel = this.levels[parseInt(expectedBudget) - 1];
      levelCountPosition = parseInt(expectedBudget);
    } else {
      for (let i = 0; i < this.levels.length; i++) {
        levelCount++;
        if (this.levels[i].dataset.active) {
          activeLevel = this.levels[i];
          levelCountPosition = levelCount;
        }
      }
    }
    this.handleValue.innerHTML = activeLevel.dataset.budget;
    this.setState({
      rangeLeft: this.range.getBoundingClientRect().left,
      levelWidth: this.levels[0].getBoundingClientRect().width,
      rangeWidth: this.range.offsetWidth,
    });
    const leftPosition = (levelCountPosition * (this.state.levelWidth + 3)) - (this.state.levelWidth / 2) - (this.handle.offsetWidth / 2);
    this.handle.style.left = `${leftPosition}px`;
    this.setState({
      handlePosition: leftPosition + (this.handle.offsetWidth / 2),
    });
    this.setLevels();
  };
  redraw = () => {
    if (this.state.windowWidth !== window.innerWidth) {
      this.init();
      this.setState({
        windowWidth: window.innerWidth,
      });
      this.setLevels();
    }
  };
  startMoving = (e) => {
    this.setState({
      moving: true,
      handleMouseOffset: this.handle.getBoundingClientRect().left - this.getMouseX(e),
    });
  };
  stopMoving = () => {
    if (this.state.moving) {
      this.setState({
        moving: false,
      });
      this.snapTo(this.state.handleSnap);
    }
  };
  move = (e) => {
    e.preventDefault();
    if (this.state.moving) {
      const left = this.getMouseX(e) - this.state.rangeLeft + this.state.handleMouseOffset;
      const leftBoundary = Math.round(-1 * (this.handle.offsetWidth / 2) + (this.state.levelWidth / 2));
      const rightBoundary = Math.round(this.state.rangeWidth - (this.state.levelWidth / 2) - (this.handle.offsetWidth / 2));
      if (left < leftBoundary) {
        this.handle.style.left = `${leftBoundary}px`;
        this.setState({
          handlePosition: leftBoundary + (this.handle.offsetWidth / 2),
        });
      } else if (left > rightBoundary) {
        this.handle.style.left = `${rightBoundary}px`;
        this.setState({
          handlePosition: rightBoundary + (this.handle.offsetWidth / 2),
        });
      } else {
        this.handle.style.left = `${left}px`;
        this.setState({
          handlePosition: left + (this.handle.offsetWidth / 2),
        });
      }
      this.setLevels();
    }
  };
  setLevels = () => {
    const { currency } = this.props;
    const levelSize = this.state.levelWidth + 3;
    let reachedLevelMin = 0;
    let reachedLevelMax = 0;
    for (let i = 0; i < this.levels.length; i++) {
      reachedLevelMin = levelSize * i;
      reachedLevelMax = reachedLevelMin + levelSize;
      if (this.state.handlePosition > reachedLevelMin && this.state.handlePosition <= reachedLevelMax) {
        this.levels[i].classList.add('budget-range__level--active');
        this.handleValue.innerHTML = this.levels[i].dataset.budget;
        this.input.setAttribute('value', `${this.levels[i].dataset.budget} ${currency}`);
        if (this.levels[i].dataset.info) {
          for (let j = 0; j < this.info.length; j++) {
            if (this.levels[i].dataset.info === this.info[j].getAttribute('id')) {
              this.info[j].classList.add('budget-range__info--active');
            } else {
              this.info[j].classList.remove('budget-range__info--active');
            }
          }
        }
        this.setState({
          handleSnap: Math.round(reachedLevelMin + ((levelSize - 3) / 2) - (this.handle.offsetWidth / 2)),
        });
      } else {
        this.levels[i].classList.remove('budget-range__level--active');
      }
    }
  };
  getMouseX = (e) => {
    if (e.type === 'mousemove' || e.type === 'mousedown') {
      return e.clientX;
    } else if (e.type === 'touchmove' || e.type === 'touchstart') {
      return e.touches[0].clientX;
    }
  };
  snapTo = (position) => {
    anime({
      targets: this.handle,
      left: position,
      duration: 200,
      easing: 'easeOutQuad',
    });
  };
  goTo = (e) => {
    const activeLevel = e.target;
    this.handleValue.innerHTML = activeLevel.dataset.budget;
    const leftPosition = activeLevel.getBoundingClientRect().left - this.state.rangeLeft + (this.state.levelWidth / 2) - (this.handle.offsetWidth / 2);
    anime({
      targets: this.handle,
      left: leftPosition,
      duration: 200,
      easing: 'easeOutQuad',
    });
    this.setState({
      handlePosition: leftPosition + (this.handle.offsetWidth / 2),
    });
    this.setLevels();
  };
  update() {
    const { moving } = this.state;
    classNames(this.handle, {
      active: moving,
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/BudgetRange.js